const KEY_PARAMS = {
  serviceID: 'sID',
  tradeID: 'tID',
  versionNO: 'vNO'
}

const KEY_DATA = {
  reqDATA: 'g_DATA',
  reqBODY: 'g_BODY'
}

const KEY_UPDATE = {
  updFIELD: 'g_FILD',
  updWHERE: 'g_WHER'
}

const KEY_HELP = {
  helpID: 'g_HELP'
}

const KEY_DICT = {
  dictID: 'g_GPID',
  dictNO: 'g_GPNO',
  dictGP: 'g_GPGP'
}

const KEY_SORT = {
  sortType: 'g_STTY',
  sortField: 'g_STFD'
}

const KEY_PAGE = {
  pageNo: 'g_PGNO',
  pageSize: 'g_PGSZ',
  rowTotal: 'g_PGAL',
  queryKey: 'g_QRID',
  funcKey: 'g_FCID',
  funcVal: 'g_FCVL'
}

const KEY_CRUD = {
  deleteID: 'g_DLID',
  recordID: 'g_RCID',
  arrayUID: 'g_ARID'
}

const KEY_CONTROL = {
  tranType: 'g_TDTY',
  ctrlFlag: 'g_CRFG'
}
export default {
  KEY_PARAMS,
  KEY_DATA,
  KEY_UPDATE,
  KEY_HELP,
  KEY_DICT,
  KEY_SORT,
  KEY_PAGE,
  KEY_CRUD,
  KEY_CONTROL
}
